module.exports = __webpack_public_path__ + "img/cc2.5c9fabc5.jpg";